import styled from "styled-components";

const Label = styled.label`
  display: inline-block;
  height: 24px;
  margin: 0;
  width: 24px;
`;

const Input = styled.input`
  cursor: pointer;
  height: 24px;
  opacity: 0;
  position: absolute;
  width: 24px;
`;

const Span = styled.span`
  clip: rect(1px, 1px, 1px, 1px);
  height: 1px;
  margin: 0;
  overflow: hidden;
  position: absolute;
  width: 1px;
`;

export { Span, Label, Input };
